/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getGlucoUsers } from 'app/entities/gluco-user/gluco-user.reducer';
import { createEntity, getEntity, reset, updateEntity } from './gynaec-history.reducer';

export const GynaecHistoryUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const glucoUsers = useAppSelector(state => state.glucoUser.entities);
  const gynaecHistoryEntity = useAppSelector(state => state.gynaecHistory.entity);
  const loading = useAppSelector(state => state.gynaecHistory.loading);
  const updating = useAppSelector(state => state.gynaecHistory.updating);
  const updateSuccess = useAppSelector(state => state.gynaecHistory.updateSuccess);

  const handleClose = () => {
    navigate(`/gynaec-history${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getGlucoUsers({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.lmp !== undefined && typeof values.lmp !== 'number') {
      values.lmp = Number(values.lmp);
    }
    if (values.periodRegular !== undefined && typeof values.periodRegular !== 'number') {
      values.periodRegular = Number(values.periodRegular);
    }
    if (values.periodCycleInterval !== undefined && typeof values.periodCycleInterval !== 'number') {
      values.periodCycleInterval = Number(values.periodCycleInterval);
    }
    if (values.parity !== undefined && typeof values.parity !== 'number') {
      values.parity = Number(values.parity);
    }
    if (values.endOfMenopause !== undefined && typeof values.endOfMenopause !== 'number') {
      values.endOfMenopause = Number(values.endOfMenopause);
    }
    if (values.papSmearDate !== undefined && typeof values.papSmearDate !== 'number') {
      values.papSmearDate = Number(values.papSmearDate);
    }
    if (values.desDate !== undefined && typeof values.desDate !== 'number') {
      values.desDate = Number(values.desDate);
    }
    if (values.sbeDate !== undefined && typeof values.sbeDate !== 'number') {
      values.sbeDate = Number(values.sbeDate);
    }
    if (values.mamogramDate !== undefined && typeof values.mamogramDate !== 'number') {
      values.mamogramDate = Number(values.mamogramDate);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...gynaecHistoryEntity,
      ...values,
      patient: glucoUsers.find(it => it.id.toString() === values.patient?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...gynaecHistoryEntity,
          patient: gynaecHistoryEntity?.patient?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.gynaecHistory.home.createOrEditLabel" data-cy="GynaecHistoryCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.gynaecHistory.home.createOrEditLabel">Create or edit a GynaecHistory</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="gynaec-history-id"
                  label={translate('tinyMedicRestApp.gynaecHistory.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecHistory.lmp')}
                id="gynaec-history-lmp"
                name="lmp"
                data-cy="lmp"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecHistory.menarche')}
                id="gynaec-history-menarche"
                name="menarche"
                data-cy="menarche"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecHistory.periodRegular')}
                id="gynaec-history-periodRegular"
                name="periodRegular"
                data-cy="periodRegular"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecHistory.periodCycleInterval')}
                id="gynaec-history-periodCycleInterval"
                name="periodCycleInterval"
                data-cy="periodCycleInterval"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecHistory.parity')}
                id="gynaec-history-parity"
                name="parity"
                data-cy="parity"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecHistory.loss')}
                id="gynaec-history-loss"
                name="loss"
                data-cy="loss"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecHistory.pain')}
                id="gynaec-history-pain"
                name="pain"
                data-cy="pain"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecHistory.vaginalDischarge')}
                id="gynaec-history-vaginalDischarge"
                name="vaginalDischarge"
                data-cy="vaginalDischarge"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecHistory.endOfMenopause')}
                id="gynaec-history-endOfMenopause"
                name="endOfMenopause"
                data-cy="endOfMenopause"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecHistory.imb')}
                id="gynaec-history-imb"
                name="imb"
                data-cy="imb"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecHistory.papSmear')}
                id="gynaec-history-papSmear"
                name="papSmear"
                data-cy="papSmear"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecHistory.papSmearResult')}
                id="gynaec-history-papSmearResult"
                name="papSmearResult"
                data-cy="papSmearResult"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecHistory.papSmearDate')}
                id="gynaec-history-papSmearDate"
                name="papSmearDate"
                data-cy="papSmearDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecHistory.infertilityHist')}
                id="gynaec-history-infertilityHist"
                name="infertilityHist"
                data-cy="infertilityHist"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecHistory.breastFeeding')}
                id="gynaec-history-breastFeeding"
                name="breastFeeding"
                data-cy="breastFeeding"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecHistory.historyOfDES')}
                id="gynaec-history-historyOfDES"
                name="historyOfDES"
                data-cy="historyOfDES"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecHistory.desObservation')}
                id="gynaec-history-desObservation"
                name="desObservation"
                data-cy="desObservation"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecHistory.desDate')}
                id="gynaec-history-desDate"
                name="desDate"
                data-cy="desDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecHistory.sbe')}
                id="gynaec-history-sbe"
                name="sbe"
                data-cy="sbe"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecHistory.sbeObsv')}
                id="gynaec-history-sbeObsv"
                name="sbeObsv"
                data-cy="sbeObsv"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecHistory.sbeDate')}
                id="gynaec-history-sbeDate"
                name="sbeDate"
                data-cy="sbeDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecHistory.momogram')}
                id="gynaec-history-momogram"
                name="momogram"
                data-cy="momogram"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecHistory.momogramObsv')}
                id="gynaec-history-momogramObsv"
                name="momogramObsv"
                data-cy="momogramObsv"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecHistory.mamogramDate')}
                id="gynaec-history-mamogramDate"
                name="mamogramDate"
                data-cy="mamogramDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecHistory.active')}
                id="gynaec-history-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecHistory.draft')}
                id="gynaec-history-draft"
                name="draft"
                data-cy="draft"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecHistory.cursor')}
                id="gynaec-history-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecHistory.lastUpdated')}
                id="gynaec-history-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecHistory.microSec')}
                id="gynaec-history-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecHistory.timestampEntry')}
                id="gynaec-history-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                id="gynaec-history-patient"
                name="patient"
                data-cy="patient"
                label={translate('tinyMedicRestApp.gynaecHistory.patient')}
                type="select"
              >
                <option value="" key="0" />
                {glucoUsers
                  ? glucoUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/gynaec-history" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default GynaecHistoryUpdate;
